import { styled } from "styletron-react"
import { motion } from "framer-motion"
import { SCROLL_START, VIDEO_RATIO } from "../../../../constants"

/**
 * SectionDetail
 */
export const Grid = styled("div", ({ $theme }) => {
  return {
    display: "grid",
    gridTemplateColumns: "6fr minmax(0, 6fr)",
    columnGap: $theme.sizing.scale700,
    [$theme.mediaQuery.large]: {
      gridTemplateColumns: "1fr",
    },
  }
})

/**
 * SectionDetailSteps
 */
export const SectionDetailStepsWrap = styled("div", ({ $theme }) => {
  return {
    background: $theme.colors.backgroundSecondary,
    padding: `0px ${$theme.sizing.scale1000}`,
    [$theme.mediaQuery.large]: {
      padding: `0px ${$theme.sizing.scale800}`,
      // restrict <Code> widths on mobile
      width: "100vw",
      boxSizing: "border-box",
    },
  }
})

/**
 * SectionDetailVideo
 */
export const SectionDetailExplorerWrap = styled("div", ({ $theme }) => {
  let gapBetweenWindow = `(100vw - ${$theme.breakpoints.large}px)/2`

  return {
    width: `calc(100% + ${gapBetweenWindow})`,
    marginLeft: `calc(${gapBetweenWindow} * -1)`,
    pointerEvents: "none",
    [$theme.mediaQuery.large]: {
      position: "sticky",
      top: `calc(100vh - ${VIDEO_RATIO * 100}vw)`,
      zIndex: $theme.zIndex.header,
      width: "100%",
      margin: "0px",
    },
  }
})
export const StickyWrap = styled("div", ({ $theme }) => {
  return {
    position: "sticky",
    top: SCROLL_START + "px",
    display: "flex", // to fit video size (height)
    [$theme.mediaQuery.large]: {
      position: "absolute",
      top: "0px",
    },
  }
})
export const FrameUnpackProgress = styled("div", ({ $theme }) => {
  return {
    background: $theme.colors.primary,
    position: "absolute",
    top: "0px",
    left: "0px",
    width: "100%",
    height: "100%",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    color: $theme.colors.contentInversePrimary,
    ...$theme.typography.ParagraphMedium,
  }
})

/**
 * Step
 */
export const StepWrap = styled("div", ({ $theme, $isFirst, $isLast }) => {
  return {
    ...getPaddingStyles({ $theme, $isFirst, $isLast }),
  }
})
export const StepInnerWrap = styled(motion.div, ({ $theme }) => {
  return {
    background: $theme.colors.backgroundPrimary,
    padding: `0px ${$theme.sizing.scale800}`,
  }
})

function getPaddingStyles({ $theme, $isFirst, $isLast }) {
  if ($isFirst) {
    return {
      paddingTop: $theme.sizing.scale4800,
      paddingBottom: $theme.sizing.scale2400,
    }
  } else if ($isLast) {
    return {
      paddingTop: $theme.sizing.scale2400,
      paddingBottom: $theme.sizing.scale4800,
    }
  }
  return {
    padding: `${$theme.sizing.scale2400} 0px`,
  }
}
